export const formatDurationMs = (durationMs: number | undefined): string | undefined => {
  if (durationMs === undefined) {
    return undefined;
  }
  return durationMs < 1000 ? `${durationMs} ms` : `${(durationMs / 1000).toFixed(1)} s`;
};
